import http from './http';

export function fetchCheckinAvailability() {
  return http.get('/checkins/availability');
}

export function submitCheckin() {
  return http.post('/checkins');
}

export function fetchCheckinRecords(params) {
  return http.get('/checkins/records', { params });
}
